import { useState, useEffect } from 'react'
import { getAllContacts, deleteContactWithId } from './../../../../../api'

function ContactForm(){
  const [allContacts, setAllContacts] = useState([])
  useEffect(async () => {
    const response = await getAllContacts();
    setAllContacts(response.data.contacts)
  }, [])

  const handleDelete = async (event, contactId) => {
    event.preventDefault()
    event.target.disabled = true

    const { data } = await deleteContactWithId(contactId)
    if (data.success && allContacts) {
      const newContacts = allContacts.filter(contact => contact._id !== data.contact._id)
      setAllContacts(newContacts)
      event.target.disabled = false
    } else {
      // Send Error Message
      event.target.disabled = false
    }

  }

  return(
    <>
      <h2>Contact forms</h2>
      <div className="table__container">
        <table className="table">
          <tr  className="table__header">
            <th>Name</th>
            <th>Phone No.</th>
            <th>Mail-id</th>
            <th>Message</th>
            <th>Delete</th>

          </tr>
          {allContacts ? allContacts.map((data, index) => {
            return (
              <tr className="table__row" key={index}>
                <td>{data.name}</td>
                <td>{data.contactNo}</td>
                <td>{data.email}</td>
                <td  className="width-min">{data.message}</td>
              <td><button onClick={(e) => handleDelete(e, data._id)}>delete</button></td>
            </tr>
            )
          }) : <></>}
          {/* <tr className="table__row">
            <td>john doe</td>
            <td>5552224646</td>
            <td>johndoe@example.com</td>
            <td>message</td>
            <td>pending</td>
          </tr> */}
        </table>
      </div>
    </>
  )
}

export default ContactForm
